export default {
    start_poll(callback, duration) {
      const timeoutId = setTimeout(callback, duration);
      return timeoutId;
    },
    stop_poll(timeoutId) {
      clearTimeout(timeoutId);
    },
        
   };